import { TokenResponse, useGoogleLogin } from '@react-oauth/google';
import { LoginButton } from '../LoginButton';
import { ELoginEvents, ELoginMethods } from 'utils/enums';
import { LoginButtonClickWrapper } from '../types';

interface GoogleLoginProps {
  callback: (response: TokenResponse) => void;
  stopLoader: () => void;
  loginButtonClickWrapper: LoginButtonClickWrapper;
  trackLoginEvent?: (eventName: string, method: ELoginMethods) => Promise<void>;
  translations: Record<string, string>;
}

export const GoogleLogin: React.FC<GoogleLoginProps> = ({
  callback,
  loginButtonClickWrapper,
  stopLoader,
  trackLoginEvent,
  translations,
}) => {
  const handleNonOAuthError = async () => {
    stopLoader();
    if (trackLoginEvent) {
      await trackLoginEvent(ELoginEvents.LOGIN_CANCELED, ELoginMethods.GOOGLE);
    }
  };
  const googleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => callback(tokenResponse),
    onNonOAuthError: handleNonOAuthError,
  });

  return (
    <LoginButton
      variant="google"
      callback={() =>
        loginButtonClickWrapper(googleLogin, ELoginMethods.GOOGLE)
      }
      text={translations?.signInWithGoogle || 'Sign in with Google'}
    >
      <img
        src="https://media.appcharge.com/defaults/google_icon.svg"
        alt="google icon"
      />
    </LoginButton>
  );
};
